import client from 'works/legacy/lib/graph-ql';
import { useEffect } from 'react';
import { gql } from '@common/hooks';

export function setActiveMenu(item) {
  if (!item) return;

  client.writeQuery({
    query: gql`
      query GetMenu {
        menu {
          id
          active
          __typename
        }
      }
    `,
    data: {
      menu: {
        id: 'menu',
        active: item,
        __typename: 'Menu',
      },
    },
  });
}

export function setActiveSecondaryMenu(item) {
  if (!item) return;

  client.writeQuery({
    query: gql`
      query GetMenu {
        menu {
          id
          secondaryActive
          __typename
        }
      }
    `,
    data: {
      menu: {
        id: 'menu',
        secondaryActive: item,
        __typename: 'Menu',
      },
    },
  });
}

export function getBreadcrumbLabel() {
  const breadcrumbs = getBreadcrumbs();

  if (
    breadcrumbs.length === 1 &&
    ['/works', '/works/supplier'].includes(breadcrumbs[0].path)
  ) {
    return 'Home Page';
  }

  return getBreadcrumbs().reduce((acc, crumb) => {
    return `${acc}${acc ? ' / ' : ''}${crumb.name}`;
  }, '');
}

export function getBreadcrumbs() {
  return (
    client.readQuery({
      query: gql(`
        query BreadcrumbsMuchoLoko {
          header {
              id
              breadcrumbs
              __typename
          }
        }
    `),
    })?.header?.breadcrumbs || []
  );
}

// Prefer the `useSetBreadcrumbs` hook over `setBreadcrumbs` function,
// except in cases where the crumbs can change.
export function setBreadcrumbs(crumbs) {
  const crumbsObj = crumbs.map(function (crumb) {
    return {
      __typename: 'Breadcrumb',
      name: crumb.name,
      path: crumb.path,
      privateInfo: !!crumb.privateInfo,
    };
  });

  client.writeQuery({
    query: gql`
      query GetMenu {
        header {
          id
          breadcrumbs
          __typename
        }
      }
    `,
    data: {
      header: {
        id: 'header',
        breadcrumbs: crumbsObj,
        __typename: 'Header',
      },
    },
  });
}

export function useSetBreadcrumbs(crumbs) {
  useEffect(() => setBreadcrumbs(crumbs), [crumbs]);
}
